import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, useUser, SignOutButton } from '@clerk/clerk-react';
import { useCart } from '../contexts/CartContext';
import { useTranslation } from '../hooks/useTranslation';
import LanguageToggle from './LanguageToggle';
import './Navigation.css';

const Navigation: React.FC = () => {
  const { isSignedIn, isLoaded } = useAuth();
  const { user } = useUser();
  const navigate = useNavigate();
  const { getCartItemCount } = useCart();
  const { t } = useTranslation();

  const isAdmin = user?.publicMetadata?.is_admin === true || user?.publicMetadata?.role === 'admin';
  const cartItemCount = getCartItemCount();

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-brand">
          Seaing You
        </Link>

        <div className="nav-links">
          <Link to="/products" className="nav-link">
            {t('nav.products')}
          </Link>

          <Link to="/cart" className="nav-link" style={{ position: 'relative' }}>
            {t('nav.cart')}
            {cartItemCount > 0 && (
              <span style={{
                position: 'absolute',
                top: '-8px',
                right: '-8px',
                backgroundColor: '#dc3545',
                color: 'white',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
              }}>
                {cartItemCount}
              </span>
            )}
          </Link>

          <LanguageToggle />

          {isLoaded && isSignedIn ? (
            <>
              <Link to="/profile" className="nav-link">
                {t('nav.profile')}
              </Link>
              
              {isAdmin && (
                <Link to="/admin" className="nav-link nav-link-admin">
                  {t('nav.adminPanel')}
                </Link>
              )}

              <div className="nav-user">
                <span className="nav-user-name">
                  {user?.fullName || user?.primaryEmailAddress?.emailAddress}
                </span>
                <SignOutButton>
                  <button className="nav-button nav-button-secondary">
                    {t('nav.signOut')}
                  </button>
                </SignOutButton>
              </div>
            </>
          ) : (
            <button 
              onClick={() => navigate('/sign-in')} 
              className="nav-button nav-button-primary"
            >
              {t('nav.signIn')}
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
